import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ViajesRevisionList as ListMem } from "./listmem";
import { FiltroViajeRevisionComponent } from "./filtro";
import { NuevoViajeRevisionCobranzaModelEdit } from "../modales";

const CrearViajeButton = kea.defaultProps(kea.Button, { style: "primary", children: "Crear viaje de revisión y cobranza", iconClass: fa("exchange") });


interface Props2 {
    value?: models.FiltroViajeCobranza;
    onChange: (x: models.FiltroViajeCobranza) => void;
    permisos: models.Rol;
}

/**Listado de los viajes de revisión */
class ViajesRevisionListControlledNoRX extends React.PureComponent<Props2> {
    modalManager = kea.createModalManager();
    filtro = (x: Props2) => x.value || {} as models.FiltroViajeCobranza;
    items = createSelectorRx(this.filtro, filtro => observeResource(resources.Cobranza2.QueryViajes, filtro));

    onCrearViaje = async () => {
        const result = await this.modalManager.showModal(NuevoViajeRevisionCobranzaModelEdit, undefined, {
            IdClientes: [],
            IdSucursal: undefined as any
        } as models.NuevoViajeCobranzaModel);
        if (result.result) {
            await resources.Cobranza2.CrearViajeCobranza(result.value);
            kea.message("Viaje creado", "Se creó un viaje de revisión y cobranza", "success");
        }
    }

    private permisos = (props: Props2) => props.permisos;
    private VerFiltroSucursalEnConsultaViajes = createSelectorRx(this.permisos, permisos => permisos.Cobranza.VerFiltroSucursalEnViajesRevision);

    render() {
        const VerFiltroSucursalEnConsultaViajes = this.VerFiltroSucursalEnConsultaViajes(this.props);
        const items = this.items(this.props);
        const filtro = this.filtro(this.props)
        return (
            <div>
                <div className="btn-group">
                    <CrearViajeButton onClick={this.onCrearViaje} />
                </div>

                <FiltroViajeRevisionComponent {...this.props} value={filtro} verSucursalCobranza={VerFiltroSucursalEnConsultaViajes} />
                <ListMem value={items} />

                {this.modalManager.component}
            </div>
        )
    }
}

interface Props {
    value?: models.FiltroViajeCobranza;
    onChange: (x: models.FiltroViajeCobranza) => void;
}

const ViajesRevisionListControlledRx = componentToRx(ViajesRevisionListControlledNoRX);
class ViajesRevisionListControlled extends React.PureComponent<Props> {
    render() {
        return <ViajesRevisionListControlledRx value={this.props.value} onChange={this.props.onChange} permisos={resources.User.PermisoRx} />;
    }
}

export const ViajesRevisionList =
    kea.makeUncontrolledCookies<Props>("value", "onChange")(ViajesRevisionListControlled) as React.ComponentClass<{ cookieKey?: string }>;



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/list/list.tsx